export default "__VITE_ASSET__BOLAb1th__"